import { render, staticRenderFns } from "./Seguranca.vue?vue&type=template&id=5bb018f0&scoped=true&"
import script from "./Seguranca.vue?vue&type=script&lang=js&"
export * from "./Seguranca.vue?vue&type=script&lang=js&"
import style0 from "./Seguranca.vue?vue&type=style&index=0&id=5bb018f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb018f0",
  null
  
)

export default component.exports